import React, { useEffect, useRef, useState, useContext } from 'react';
import { Button, Card, CardActions, CardText, CardTitle, FocusContainer, FontIcon, Grid, Cell, ResizeObserver, TextField } from 'react-md';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import QMlogo from '../images/png/EQM.png';
import logo from '../images/png/SF-Logo.png';
import ApiRequestService from './ApiRequestService';
//Local Imports
import Properties from './Properties';
import { AppProperties, IsPublicSite } from '../common/function'
import "./FormLogin.css"
import { browserHistory } from 'react-router';
import { AppContext } from './context/AppContext';

//const appProperties = new Properties();
//const emailRegex = new RegExp(/[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/);

const styles = {
    container:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding:'1em'
    },
    loginPanel:{
        maxWidth:'25%',
        minWidth:'450px' 
    },
    univName: {
        fontSize:'3rem',
        textAlign:'center',
        fontWeight:'bold',
        margin:'0rem',
        padding:'1.5rem 0rem'
    },
    imageContainer:{
        padding:'0.5em'
    },
    image:{
        maxWidth:'100%',
        cackgroundColor:'#bb000'
    },
    underline:{textDecoration:'underline'}
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const getWhiteListFromServer = function(force){
    return new Promise((resolve, reject) => {
        
        ApiRequestService({
            method: 'get',
            url: '/whitelist'
        }).then(res => {
            if (res.data.message !== null && res.data.message !== '') {
                reject(res.data.message);
            }
        else{
            let whitelist  = res.data.data; 
            resolve(whitelist);                     
        }
        }).catch(err =>{
            reject(err);
        });
        
    });
}

const FormLogin = (props) =>{
    const appProperties = AppProperties();
    const [height,setHeight] = useState(window.innerHeight);
    const [formShown,setFormShown] = useState(() => {
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get('form') === 'register' ? 'register' : 'login';
    });
    const [mailWhiteList,setMailWhiteList] = useState([]);
    const [loading,setLoading] = useState(false);

    console.debug("appProperties", appProperties);

    const handleResize = ({height}) => {
        setHeight(height);
    };

    useEffect(()=>{
        setLoading(true);
        getWhiteListFromServer(false).then(whitelist=>setMailWhiteList(whitelist.slice())).finally(()=>{
            setLoading(false);
        });
    },[])

    if(loading){
        return <BeatLoader color='#bb0000' loading={true} size={10} />
    }
    return  <React.Fragment>
                <FocusContainer
                    style={{...styles.container,height}}
                    focusOnMount
                    containFocus={true}
                    component="form"
                    className="md-grid"
                >
                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                    {/* <div style={{color:"#333", fontSize:"2rem", width:"350px", textAlign:"center"}}>{appProperties?.universityFullName}
</div> */}
                    {/* <div style={{marginBottom:"6px", fontSize:"1.6rem"}}>Instructor Website</div> */}
                    {formShown === "register" ? <div style={{marginBottom:"6px", marginTop:'2rem', fontSize:"1.6rem"}}>Registration for Instructor Access</div> : null}
                    {
                        formShown === 'register'?
                        <RegisterForm whitelist={mailWhiteList} changeForm={setFormShown} apiService={props.apiService}/>:
                        formShown === 'forgotPassword'?
                        <ForgotPassword whitelist={mailWhiteList} changeForm={setFormShown} apiService={props.apiService}/>:
                        formShown === 'checkEmail'?
                        <CheckEmail changeForm={setFormShown} apiService={props.apiService}/>:
                        formShown === 'checkEmailForgetPassword'?
                        <CheckEmailForgetPassword changeForm={setFormShown} apiService={props.apiService}/>:
                        <LoginForm whitelist={mailWhiteList} changeForm={setFormShown} apiService={props.apiService}/>
                    }
                    <div style={{textAlign:"center", width:"100%", display:"inline-block", padding:"12px 0px", width:"350px", fontSize:"16px"}}>If you are a student, do not use this website. Instead use: <a href={`${appProperties.appURL.replace("cpanel", "student")}`}>{appProperties?.appURL?.replace("cpanel", "student")}</a></div>     
                    </div>              
                </FocusContainer>
                <ResizeObserver watchHeight onResize={handleResize} />
                <NotificationContainer/>

            </React.Fragment>
            
}

const RegisterForm = (props) => {
    const appProperties = AppProperties();
    const fNameRef = useRef(null);
    const lNameRef = useRef(null);
    const emailRef = useRef(null);
    const organizationRef = useRef(null);
    const positionRef = useRef(null);
    const verificationLinkRef = useRef(null);
    const intendedUseRef = useRef(null);
    const passwordRef = useRef(null);
    const [loading,setLoading] = useState(false);
    const passwordConfirmRef = useRef(null);
    const mailDomains = appProperties.mailDomain.split(";");
    const mailIDError = `Enter a valid ${mailDomains.length > 1 ? mailDomains.join(' or ') : mailDomains} id`;
    const [passwordError1,setPasswordError1] = useState(false);
    const [passwordErrorText1,setPasswordErrorText1] = useState('Please enter the password');
    const [emailError,setEmailError] = useState(false);
    const [passwordError,setPasswordError] = useState(false);
    const [passwordErrorText,setPasswordErrorText] = useState('Please enter the password again')
    const [emailErrorMessage, setEmailErrorMessage] = useState("Please enter a valid email address");
    const [organizationErrorMessage, setOrganizationErrorMessage] = useState("Please enter your institution/organization");
    const [positionErrorMessage, setPositionErrorMessage] = useState("Please enter your position");
    const [intendedUseErrorMessage, setIntendedUseErrorMessage] = useState("Please add your intended use of SF");
    const [isPublicSite, setIsPublicSite] = useState(IsPublicSite());
    const {whitelist} = props;
   
    const validatePassword = (passwrod)=> {

        
       
        if (passwrod.match(/[a-z]/g) && passwrod.match( 
                /[A-Z]/g) && passwrod.match( 
                /[0-9]/g) && passwrod.match( 
                /[^a-zA-Z\d]/g) && passwrod.length >= 8) 
           return true;
        else 
            return false; 
    }

    const isValid = () => {
        setPasswordError(false);
        setPasswordError1(false);
        setEmailError(false);
        if(fNameRef.current.value.length <= 0){
            fNameRef.current.focus();
            return false;
        }

        if(lNameRef.current.value.length <= 0){
            lNameRef.current.focus();
            return false;
        }

        if(emailRef.current.value.length <= 0){
            emailRef.current.focus();
            return false;
        } else if (!emailRegex.test(emailRef.current.value)) {
            setEmailError(true);
            setEmailErrorMessage("Please enter a valid email address");
            emailRef.current.focus();
            return false;
        }else{
            
           // let domainName =  emailRegex.exec((emailRef.current.value).toLowerCase());
           let domainName = ((emailRef.current.value).toLowerCase()).split("@");
            console.debug("DOMAIN NAME ",domainName,emailRef.current.value,domainName[0].length,domainName[0]);
            console.debug("appProperties ",appProperties.mailDomain,domainName[0].includes(appProperties.mailDomain));

            // if we are not allowing all email domains register, validate domain
            if (appProperties.mailDomain !== "any") {
                if(!(domainName.length > 1) || !((domainName[0].trim()).length > 1) || ((!domainName ||!mailDomains.includes(domainName[1])) && (!whitelist.includes((emailRef.current.value).toLowerCase()))) ){
                    console.log('mismatch',!(domainName.length > 1) , !((domainName[0].trim()).length > 1) , !domainName );
                    setEmailError(true);
                    setEmailErrorMessage(mailIDError);
                    emailRef.current.focus();
                    return false;
                }
            }
        }

        if (isPublicSite) {
            if (organizationRef.current.value.length <= 0) {
                organizationRef.current.focus();
                return false;
            }
    
            if (positionRef.current.value.length <= 0) {
                positionRef.current.focus();
                return false;
            }
    
            if (intendedUseRef.current.value.length <= 0) {
                intendedUseRef.current.focus();
                return false;
            }
        }

        if(!validatePassword(passwordRef.current.value)){
            setPasswordError1(true);
            setPasswordErrorText1(`Password should contain
            atleast 1 uppercase character,
            atleast 1 lowercase character,
            atleast 1 digit,
            atleast 1 special character and
            should be minimum 8 characters`);
            passwordRef.current.focus();
            return false;
        }

        if(passwordConfirmRef.current.value.length <= 0){
            passwordConfirmRef.current.focus();
            return false;
        }else{
            
            if(passwordConfirmRef.current.value !== passwordRef.current.value){
                
                setPasswordErrorText('Both Passwords must match');
                setPasswordError(true)
                passwordConfirmRef.current.focus();
                return false;
            }
        }

        return true;
    }
    const register = () =>{
        
        if(isValid()){
            let payload = {
                emailID:emailRef.current.value,
                password:passwordRef.current.value,
                firstName:fNameRef.current.value,
                lastName:lNameRef.current.value,
                userName:emailRef.current.value.substring(0, emailRef.current.value.indexOf("@")),

                organization: organizationRef.current?.value ?? "",
                position: positionRef.current?.value ?? "",
                verification_link: verificationLinkRef.current?.value ?? "",
                intended_use: intendedUseRef.current?.value ?? "",
            }

            if (!window.location.hostname.includes("app.cpanel")) {
                payload.is_university = true
            }

            setLoading(true);
            let responsePromise = ApiRequestService({method: 'post',
            url: '/registerUser',
            skipErrorHandle:true,
            data: payload});
              responsePromise.then(res => {
                if(res.data){
                    if(res.data && res.data.status === 1 && res.data.message){
                        if( res.data.message === 'DUPLICATE REGISTRATION'){
                            NotificationManager.error("Duplicate Registration detected, please request your instructor to activate your account. If you forgot your password, please click on Forgot Password", 'ERROR', 10000);
                            return;
                        }
                        NotificationManager.error(res.data.message, 'ERROR', 10000);
                        return;
                    }
                    window.localStorage.setItem("registerationEmail", payload.emailID);
                    props.changeForm('checkEmail');
                }
                else{
                    NotificationManager.error("Server didn't respond", 'ERROR', 10000);
                    return;
                }

              }).catch(error => {
                  console.log(error);
                NotificationManager.error("Unable to Register, please contact your course instructor", 'ERROR', 10000);
              }).finally(()=>{
                setLoading(false);
              });
        }
    }

    if(loading){
        return <BeatLoader color='#bb0000' loading={true} size={10} />
    }
    
    return <Card style={styles.loginPanel} className="md-block-centered">
                <div className='bg-color-primary' style={styles.imageContainer}>
                    {appProperties.eqmMode?
                        <img  style={styles.image} alt="EQM" title="EQuiMaster" src={QMlogo} />
                    :
                        <img  style={styles.image} alt="Stem Fluency" title="Stem Fluency" src={logo} />  
                    } 
                </div>
                {/* <CardTitle title='User Registration'></CardTitle> */}
                <CardText style={{position:'relative'}} className='registration-container'>
                    <Grid style={{margin: "-10px", padding: 0 }}>
                        <Cell size={6}>
                            <TextField fullWidth aria-describedby="name-format" aria-required="true" errorText='Please enter your first name' autoComplete='firstName' id='firstName' ref={fNameRef} label='First Name' required  placeholder='Enter your first name'></TextField>
                        </Cell>

                        <Cell size={6}>
                            <TextField fullWidth aria-describedby="name-format" aria-required="true" errorText='Please enter your last name' autoComplete='lastName' id='lastName' ref={lNameRef} label='Last Name' required   placeholder='Enter your last name'></TextField>
                        </Cell>
                    </Grid>

                    <TextField error={emailError} aria-describedby="email-format" aria-required="true" errorText={emailErrorMessage} autoComplete='email' id='email' ref={emailRef} label='Email ID' required   placeholder='Enter your university email address' type='email'></TextField>
                    
                    {isPublicSite ? 
                    <React.Fragment>
                        <TextField error={null} aria-describedby="organization-format" aria-required="true" errorText={organizationErrorMessage} autoComplete='organization' id='organization' ref={organizationRef} label='Instiution/Organization' required   placeholder='Enter your Institution/Organization name' type='text' maxLength={200}></TextField>
                        
                        <TextField error={null} aria-describedby="position-format" aria-required="true" errorText={positionErrorMessage} autoComplete='position' id='position' ref={positionRef} label='Your Position' required   placeholder='Enter your Position' type='text' maxLength={200}></TextField>

                        <TextField error={null} maxLength={200} aria-describedby="verification-format" aria-required="true" errorText={null} autoComplete='verification' id='verification' ref={verificationLinkRef} label='Link verifying your position' placeholder='Provide a link to confirm your organization or position' type='text'></TextField>

                        <TextField error={null}
                        rows={2}
                        aria-describedby="intended-use-format" aria-required="true" errorText={intendedUseErrorMessage} autoComplete='position' id='position' ref={intendedUseRef} label='Intended Use of Stemfluency' required placeholder='Tell us how you plan to use Stemfluency for teaching, research, or training.' type='text'></TextField>
                    </React.Fragment> 
                    : null}


                    <Grid style={{margin: "-10px", padding: 0 }}>
                        <Cell size={6}>
                            <TextField   error={passwordError1} aria-describedby="password-format" aria-required="true" errorText={passwordErrorText1} autoComplete='new-password' id='password' ref={passwordRef} label='Password' required  placeholder='Enter your password'  type="password"></TextField>
                        </Cell>
                        <Cell size={6}>
                            <TextField  error={passwordError} aria-describedby="password-format" aria-required="true" errorText={passwordErrorText} autoComplete='new-password' id='password-confirm' ref={passwordConfirmRef} label='Confirm password' required  placeholder='Enter your essential skills password'  type="password"></TextField>
                        </Cell>
                    </Grid>
                </CardText>
                <CardActions >
                    <Button style={styles.underline} className="md-cell--left" flat primary onClick={()=>props.changeForm('login')} >Cancel</Button>
                    <Button  className="md-cell--right" primary raised onClick={register} >Submit</Button>
                </CardActions>
           </Card>
}

const CheckEmail = (props) =>{
    const appContext = useContext(AppContext);
    return <Card  style={{padding:'20px'}}>
        <center><h2  style={{color:'#333'}}>Thank you for registering.</h2></center>
        <h3 style={{ color: '#333', textAlign:"center", marginTop:'6px' }}>
                    <React.Fragment>
                        <div>You will receive an email once your registration has been verified. </div>
                        After verification, you can log in to the <strong>cPanel site</strong> and start creating your own course and assignments.

                        <br /><br />
                        <div>The verification process might take some time. Please be patient.</div>
                        {/* <center style={{ color: '#bb0000', paddingTop: "22px" }}>
                            Please check your email (<u>Spam/Quarantine</u> folder too)
                        </center> */}
                    </React.Fragment>
            </h3>
    </Card>
}

const LoginForm = (props) => {
    const appProperties = AppProperties();
    // const emailRef = useRef(null)
    const passwordRef = useRef(null)
    const [emailError,setEmailError] = useState(false);
    const [loading,setLoading] = useState(false);
    const mailDomains = appProperties.mailDomain.split(";");
    const mailIDError = `Enter a valid ${mailDomains.length > 1 ? mailDomains.join(' or ') : mailDomains} id`;
    const {whitelist} = props;

    const [selectedTab, setSelectedTab] = useState('password');
    const codeRef = useRef(null);
    const [showCodeError,setShowCodeError] = useState(false);
    const [isCodeRequested, setIsCodeRequested] = useState(false);
    const [haveTheCode, setHaveTheCode] = useState(false);
    const [email, setEmail] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState("Please enter a valid email address");

    
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const tabParam = queryParams.get('type');
        const queryEmail = queryParams.get('email');
        if (tabParam === 'register') {
            setSelectedTab('otp');
            setHaveTheCode(true);
            console.debug("queryEmail", queryEmail)
            setIsCodeRequested(true);
            console.debug("codeRef", codeRef.current);
            if (codeRef.current) {
                codeRef.current.focus();
            }
            setEmail(queryEmail || window.localStorage.getItem("registerationEmail"));

        } else if (tabParam === "requestcode") {
            setSelectedTab('otp');
            setEmail(queryEmail || window.localStorage.getItem("registerationEmail"));
        }

    }, [window.location.search])

    useEffect(() => {
        console.debug("LoginForm called", window.location.search);
        const queryParams = new URLSearchParams(window.location.search);
        let token = queryParams.get('token')
        console.debug("LoginForm token", token)
        if (token) {
            setLoading(true)
            const [encodedHeader, encodedPayload, signature] = token.split('.');
            let decodedPayload;
            try {
                decodedPayload = JSON.parse(atob(encodedPayload));    
            } catch (error) {
                console.error("Unable to decode the token", token, error)
                NotificationManager.error(`Unable to decode the token: ${token}`, "ERROR", 3000)
                setLoading(false);
                return;
            }

            console.debug("decodedPayload", decodedPayload)

            if (decodedPayload && decodedPayload.role === 3) {
                alert("Please contact your Administrator to gain access to the cPanel");
                if (queryParams.has('token')) {
                    queryParams.delete('token');
                    const newSearch = queryParams.toString();
                    const newPath = `${window.location.pathname}?${newSearch}`;
    
                    const encodedPath = encodeURI(newPath);
    
                    console.debug("encodedPath", encodedPath)
    
                    window.history.replaceState(null, '', encodedPath);
                }
                return;
            }

            if (decodedPayload) {
                window.localStorage.setItem("isLTIStudent", decodedPayload.isLTIStudent);
                appProperties.currentUserData.setUserDetails(decodedPayload,appProperties.loginType);
            }
            

           // Remove the token once it's been used
           if (queryParams.has('token')) {
                queryParams.delete('token');
                const newSearch = queryParams.toString();
                const newPath = `${window.location.pathname}?${newSearch}`;

                const encodedPath = encodeURI(newPath);

                console.debug("encodedPath", encodedPath)

                window.history.replaceState(null, '', encodedPath);
                window.location.reload();
            }
        }
    }, [])

    const login = (e) =>
    {
        if(!isValid()){
            e.preventDefault();
            return;
        }
        setLoading(true);
      let responsePromise = ApiRequestService({method: 'post',
      skipErrorHandle:true,
      url: '/login',
      data: {
        // emailID:emailRef.current.value,
        emailID:email,
        password:passwordRef.current.value
      }});
        responsePromise.then(res => {
            
            
            if(res.data){
                if(res.data && res.data.status === 1 && res.data.message){
                    setLoading(false);
                    if (res.data.message === "user not activated"){
                        alert(`Sorry, your account is still not verified. The verification process might take some time. Please be patient.`);
                    }else if (res.data.message === "user rejected") {
                        alert("Your account has been rejected. Please contact your administrator for more details.");
                    } else {
                        NotificationManager.error(res.data.message, 'ERROR', 10000);
                    }
                    return;
                }
                appProperties.currentUserData.setUserDetails(res.data.data,appProperties.loginType);
                if(appProperties.loginType === "form" && res.data.data !== undefined && res.data.data !== null &&
                  res.data.data.role === 0){
                    alert("Please contact your Administrator to gain access to the cPanel");
                    setLoading(false);
                    return;
                }
                window.location.reload();
            }
            else{
              setLoading(false);
                NotificationManager.error("Server didn't respond", 'ERROR', 10000);
                return;
            }
           
        })
        responsePromise.catch(error => {
          setLoading(false);
            console.log(error);
            NotificationManager.error("Unable to Login, please check your email id and password", 'ERROR', 10000);
        });

        responsePromise.finally(()=>{

        })
    }

    const isValid = () => {
        setEmailError(false);
        if(email?.length <= 0){
            // emailRef.current.focus();
            return false;
        } else if (!emailRegex.test(email)) {
            setEmailError(true);
            setEmailErrorMessage("Please enter a valid email address");
            return false;
        } else{
            
           // let domainName =  emailRegex.exec((emailRef.current.value).toLowerCase());
           let domainName = ((email).toLowerCase()).split("@");
            console.log(domainName);
            console.log(appProperties.mailDomain);

            // if we are not allowing all email domains register, validate domain
            if (appProperties.mailDomain !== "any") {
                if(!(domainName.length > 1) || !((domainName[0].trim()).length > 1) || (((!domainName ||!mailDomains.includes(domainName[1])) && (!whitelist.includes((email).toLowerCase())))) ){
                    console.log('mismatch');
                    setEmailError(true);
                    setEmailErrorMessage(mailIDError);
                    // emailRef.current.focus();
                    return false;
                }
            }
        }

        if (selectedTab === "password") {
            if(passwordRef.current.value.length <= 0){
                passwordRef.current.focus();
                return false;
            }
        } else {
            if (isCodeRequested) {
                // check code is valid
                if (codeRef?.current?.value.length !== 6) return false;
            }
        }

        /* if(passwordRef.current.value.length <= 0){
            passwordRef.current.focus();
            return false;
        } */

        return true;
    }

    
    const clearAllNotifications = () => {
        NotificationManager.listNotify.forEach(n => {
                NotificationManager.remove({ id: n?.id })
        });
    }

    const handleTabChange = (val) => {
        // removeQueryParams()
        setIsCodeRequested(false);
        setHaveTheCode(false);
        setSelectedTab(val);  
    }

    const handleCodeSubmit = () => {
        setShowCodeError(false);
        clearAllNotifications();
        console.debug("codeRef.current.value;", codeRef.current.value)
        let code = codeRef.current.value;
        // let emailID = emailRef.current.value;
        let emailID = email;
        code.trim();

        if (!isValid()) {
            setShowCodeError(true);
            return;
        }

        setLoading(true);
        const response = ApiRequestService({
            method: 'post',
            skipErrorHandle: false,
            url: '/verifyCode',
            data: {
                code,
                emailID,
                type: 'activation-code'
            }
        });
        response.then(res => {
            console.debug("res", res);
            if (res && res.data) {
                const data = res.data;
                if (data?.status === 1) { // Verification failed
                    if (data.message === "student account error") {
                        alert(`Sorry, your account is still not verified. The verification process might take some time. Please be patient.`);
                    } else {
                        NotificationManager.error(data.message, 'ERROR', 5000);
                    }
                } else { // Success
                    // TODO: Change this message when the account is already activated and users simply trying to login with code 
                    NotificationManager.success("Your account has been activated.\n\nYou'll be logged in shortly", 'SUCCESS', 2000);
                    console.debug("browserHistory", browserHistory);
                    // Login the user with the token
                    // if this is a new instructor and does not have access to cpanel, show the alert
                    // alert("Please contact your Administrator to gain access to the cPanel");
                    browserHistory.push(`?token=${data.data}`);
                    window.location.reload();
                }

            }
            
        }).finally(() => {
            setLoading(false);
        })
    }

    const onSubmit = (event) =>{
        event.preventDefault();
        if (selectedTab === "password") {
            login(event);
        } else {
            if(!isValid()){
                event.preventDefault();
                return;
            }
            if (isCodeRequested) {
                let code = codeRef.current.value;
            } else {
                // let emailID = emailRef.current.value;
                let emailID = email;
                getCode(emailID);
            }
        }
    }

    const getCode = (emailID) => {
        setLoading(true);
        const response = ApiRequestService({
            method: 'post',
            skipErrorHandle: false,
            url: '/sendCode',
            data: {
                emailID,
            }
        });

        response.then(res => {
            if (res && res.data.status === 0) {
                NotificationManager.success("A verification code should be sent to your email address. Please check in spam and quarantine folders too", "Success", 10000);
                setHaveTheCode(true);
                setIsCodeRequested(true);
            } else {
                if (res?.data?.message === "user rejected") {
                    alert("Your account has been rejected. Please contact your administrator for more details.");
                } else {
                    NotificationManager.error(res?.data?.message, "ERROR", 10000)
                }
            }
            
        }).finally(() => {
            setLoading(false)
        })
    }


    /* if(loading){
        return <BeatLoader color='#bb0000' loading={true} size={10} />
    } */

    return <form onSubmit={login}  style={styles.loginPanel} >
                <Card  className="md-block-centered">
                    <div className='bg-color-primary' style={styles.imageContainer}>
                    {appProperties.eqmMode?
                        <img  style={styles.image} alt="EQM" title="EQuiMaster" src={QMlogo} />
                    :
                        <>
                        <img  style={styles.image} alt="Stem Fluency" title="Stem Fluency" src={logo} />  
                        </>
                    }   
                    </div>

                    <div className='login-tabs'>
                        <div className={`${selectedTab === 'password' ? 'selected-tab' :''}`} 
                        onClick={(event) => {
                            event.preventDefault();
                            handleTabChange("password")
                        }}>Login Using Password</div>
                        <div className={`${selectedTab === 'otp' ? 'selected-tab' :''}`} onClick={(event) => {
                            event.preventDefault();
                            handleTabChange("otp")
                        }}>Login with One Time Code</div>
                        
                    </div>

                    <CardText>
                        <TextField value={email} 
                        onChange={(val) => {
                            setEmail(val)
                        }}
                        autoComplete='email'error={emailError}  errorText={emailErrorMessage} id='email' //ref={emailRef} 
                        label='Email ID' required  leftIcon={<FontIcon>email</FontIcon>} placeholder='Enter your university email address'></TextField>
                        {selectedTab === "password" ? 
                        <TextField  errorText='Enter your password' autoComplete='current-password' id='password' ref={passwordRef} label='Password' required leftIcon={<FontIcon>lock</FontIcon>} placeholder='Enter your essential skills password'  type="password"></TextField>
                        : null}

                            <TextField
                                ref={codeRef}
                                autoComplete={false}
                                error={showCodeError}
                                leftIcon={<FontIcon>lock</FontIcon>}
                                errorText={"Enter the code you received in the email."}
                                id='twofa_code'
                                placeholder='Enter the code'
                                style={{
                                    // visibility: selectedTab === "otp" & (isCodeRequested || haveTheCode) ? 'visible' : 'hidden',
                                    // height: selectedTab === "otp" & (isCodeRequested || haveTheCode) ? 'fit-content' : '0px',
                                    opacity: selectedTab === "otp" & (isCodeRequested || haveTheCode) ? '100%' : '0%',
                                    zIndex: selectedTab === "otp" & (isCodeRequested || haveTheCode) ? '1' : '-1',
                                }}
                                required
                                // className='code-text-field'
                            />

                    </CardText>
                    <CardActions  style ={{padding:"0px",justifyContent: "center"}}>
                    {/* <Button type='submit'  primary raised onClick={login}>Login</Button> */}
                        
                    <Button disabled={loading} primary raised onClick={(event) => {
                            console.debug("isCodeRequested", isCodeRequested, haveTheCode)
                            if (isCodeRequested || haveTheCode) {
                                handleCodeSubmit();
                            } else {
                                onSubmit(event)
                            }
                        }}>
                            <BeatLoader color='white' loading={loading} size={5}></BeatLoader>
                            {loading ? null : (selectedTab === "password" ? "Login" : (isCodeRequested || haveTheCode ? "Login" :"Request One Time Code"))}
                        </Button>

                    </CardActions>
                    <CardActions >
                        <Button disabled={loading} style={styles.underline} className="md-cell--left" flat primary onClick={()=>props.changeForm('register')}>Register</Button>
                        
                        {selectedTab === "otp" ?
                            <Button disabled={loading} style={styles.underline} className={`${selectedTab === "otp" ? "md-cell--right" : ""}`} flat primary onClick={() => {
                                if (selectedTab === "password") {
                                    props.changeForm('register')
                                } else if (!haveTheCode) {
                                    setHaveTheCode(true);
                                } else {
                                    setHaveTheCode(false);
                                    setIsCodeRequested(false);
                                }
                                
                            }}>{selectedTab === "password" ? "Register" : (haveTheCode ? "Request Another Code" : "I already have the Code")}</Button>
                            : null}
                            {selectedTab === "password" ? 
                            <Button style={styles.underline} className="md-cell--right" flat primary onClick={() => {
                                setSelectedTab("otp");
                            }}>Forgot Password</Button>
                            : null}

                        {/* <Button style={styles.underline} className="md-cell--right" flat primary onClick={()=>props.changeForm('forgotPassword')}>Forgot Password</Button> */}
                    </CardActions>
                 </Card>
           </form>
}


const CheckEmailForgetPassword = (props) =>{
    return <Card  style={{padding:'20px'}}>
        <center><h2  style={{color:'#333'}}>Request Received.</h2></center>
            <h1 style={{color:'#333'}}>You will receive an email with instructions to change the password. 
                <center style={{color:'#bb0000',paddingTop:" 22px"}}>Please check your email(spam folder too)</center></h1>
    </Card>
}

const ForgotPassword = (props) => {
    const emailRef = useRef(null)
    const appProperties = AppProperties();
    const [emailError,setEmailError] = useState(false);
    const [loading,setLoading] = useState(false);
    const mailDomains =  appProperties.mailDomain.split(";");
    const mailIDError = `Enter a valid ${mailDomains.length > 1 ? mailDomains.join(' or ') : mailDomains} id`;
    const [emailErrorMessage, setEmailErrorMessage] = useState("Please enter a valid email address");
    const {whitelist} = props;
    
    const forgotPassword = () =>
    {      
        
        if(!isValid()){
            
            return;
        }
        setLoading(true);
      let responsePromise = ApiRequestService({method: 'post',
      skipErrorHandle:true,
      url: '/forgotPassword',
      data: {
        emailID:emailRef.current.value
      }});
        responsePromise.then(res => {
            if(res.data){
                if(res.data && res.data.status === 1 && res.data.message){
                    NotificationManager.error(res.data.message, 'ERROR', 10000);
                    return;
                }
                NotificationManager.success("Please check your email for instructions to reset your password.", 'SUCCESS', 30000);
                props.changeForm('checkEmailForgetPassword');
            }
            else{
                NotificationManager.error("Server didn't respond", 'ERROR', 10000);
                return;
            }
            
        })
        responsePromise.catch(error => {
            console.log(error);
            NotificationManager.error("Unable to perform password reset", 'ERROR', 3000);
        });

        responsePromise.finally(()=>{
            setLoading(false);
            props.changeForm('checkEmailForgetPassword');
        })
    }

    const isValid = () => {
        setEmailError(false);
        if(emailRef.current.value.length <= 0){
            emailRef.current.focus();
            return false;
        } else if (!emailRegex.test(emailRef.current.value)) {
            setEmailError(true);
            setEmailErrorMessage("Please enter a valid email address");
            emailRef.current.focus();
            return false;
        } else{
            let domainName = ((emailRef.current.value).toLowerCase()).split("@");
            //let domainName =  emailRegex.exec(emailRef.current.value);

            // if we are not allowing all email domains register, validate domain
            if (appProperties.mailDomain !== "any") {
                if(!(domainName.length > 1) || !((domainName[0].trim()).length > 1) || ((!domainName ||!mailDomains.includes(domainName[1])) && (!whitelist.includes((emailRef.current.value).toLowerCase()))) ){
                    setEmailError(true);
                    setEmailErrorMessage(mailIDError);
                    emailRef.current.focus();
                    return false;
                }
            }
        }


        return true;
    }

    if(loading){
        return <BeatLoader color='#bb0000' loading={true} size={10} />
    }

    return <Card style={styles.loginPanel} className="md-block-centered">
                <div className='bg-color-primary' style={styles.imageContainer}>
                {appProperties.eqmMode?
                        <img  style={styles.image} alt="EQM" title="EQuiMaster" src={QMlogo} />
                    :
                        <img  style={styles.image} alt="Stem Fluency" title="Stem Fluency" src={logo} />  
                    }    
                </div>
                <CardTitle subtitle='Forgot Password'></CardTitle>
                <CardText>
                    <TextField error={emailError} autoComplete='email' errorText={emailErrorMessage} id='email' ref={emailRef} label='Email ID' required  leftIcon={<FontIcon>email</FontIcon>} placeholder='Enter your university email address'></TextField>
                </CardText>
                <CardActions >
                    <Button style={styles.underline} className="md-cell--left" flat primary onClick={()=>props.changeForm('login')} >Cancel</Button>
                    <Button className="md-cell--right" primary raised onClick={forgotPassword}>Submit</Button>
                </CardActions>
           </Card>
}

export default FormLogin;